import {NgModule} from '@angular/core';
import {OcrService} from './ocr.service';
import {StompConfig, StompService} from '@stomp/ng2-stompjs';
import stompConfig from './stomp.config';

@NgModule({
    providers: [
        OcrService,
        StompService,
        {
            provide: StompConfig,
            useValue: stompConfig
        }
    ]
})
export class OCrModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/components/ocr/ocr.module.ts